import React from "react";
import api from '../../api/Api'
// @material-ui/core components
import FormLabel from "@material-ui/core/FormLabel";
import {NavLink} from 'react-router-dom';

import Loader from '../../components/Loader'

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import {
    verifyEmail,
    verifyName,
    verifyNumber,
    verifyPhoneNumber,dashboardRouter
} from '../../util/globalHelper'

export default class updateClinicMaster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //validaton
            number: "",
            numberState: "",
            name: "",
            nameState: "",
            adminName: "",
            adminNameState: "",
            contactNumber: "",
            contactNumberState: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            redirect: false,
            redirectToDash: false,
            clinicmaster_id: ""
        };
        this.typeClick = this.typeClick.bind(this);
    }

    componentDidMount() {
        this.callReadAPI(this.props.match.params.clinicmasterID)

    }

    callReadAPI(id) {
        api.getClinicMasterById(id).then(({data}) => {
            this.setState({
                data: data.data,
                clinicmaster_id: id,
                name: data.data.clinicmaster_name,
                adminName: data.data.clinicmaster_adminname,
                companyNumber: data.data.clinicmaster_companynumber,
                contactNumber: data.data.clinicmaster_contactinfo,
                nameState: data.data.clinicmaster_name !== "" && data.data.clinicmaster_name ? "success" : "error",
                adminNameState: data.data.clinicmaster_adminname !== "" && data.data.clinicmaster_adminname ? "success" : "error",
                contactNumberState: data.data.clinicmaster_contactinfo !== "" && data.data.clinicmaster_contactinfo ? "success" : "error",
                companyNumberState: data.data.clinicmaster_companynumber !== "" && data.data.clinicmaster_companynumber ? "success" : "error",
            })

        })
    }


    render() {
        const {data} = this.state;
        if (this.state.data) {
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4>Update Clinic Master</h4>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            <GridItem xs={12} sm={2} className="margin-t-30">
                                                <FormLabel>
                                                    Name
                                                </FormLabel>
                                            </GridItem>
                                            <GridItem xs={12} sm={8}>
                                                <CustomInput
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name"),
                                                        value: this.state.name
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>

                                            <GridItem xs={12} sm={2} className="margin-t-30">
                                                <FormLabel>
                                                    Company Number
                                                </FormLabel>
                                            </GridItem>
                                            <GridItem xs={12} sm={8}>
                                                <CustomInput
                                                    success={this.state.companyNumberState === "success"}
                                                    error={this.state.companyNumberState === "error"}
                                                    id="companynumber"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "companyNumber", "number"),
                                                        value: this.state.companyNumber
                                                    }
                                                    }
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={2} className="margin-t-30">
                                                <FormLabel>
                                                    Admin Name
                                                </FormLabel>
                                            </GridItem>
                                            <GridItem xs={12} sm={8}>
                                                <CustomInput
                                                    success={this.state.adminNameState === "success"}
                                                    error={this.state.adminNameState === "error"}
                                                    id="adminname"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "adminName", "name"),
                                                        value: this.state.adminName
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={2} className="margin-t-30">
                                                <FormLabel >
                                                    Contact Number
                                                </FormLabel>
                                            </GridItem>
                                            <GridItem xs={12} sm={8}>
                                                <CustomInput
                                                    success={this.state.contactNumberState === "success"}
                                                    error={this.state.contactNumberState === "error"}
                                                    id="url"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                        value: this.state.contactNumber
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer style={{ justifyContent:"center" }}>
                                        <GridItem xs={12} sm={3}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Update
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                            <NavLink
                                                to={dashboardRouter(`/clinicmaster/oneClinicMaster/${data.clinicmaster_id}`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        }
        else  return (<Loader/>)

    }

    change(event, stateName, type, stateNameEqualTo, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;

            default:
                break;
        }
    }

    typeClick() {
        if (this.state.nameState === "") {
            this.setState({nameState: "error"});
        }
        if (this.state.companyNumberState === "") {
            this.setState({companyNumberState: "error"});
        }
        if (this.state.contactNumberState === "") {
            this.setState({contactNumberState: "error"});
        }
        if (this.state.adminNameState === "") {
            this.setState({adminNameState: "error"});
        }
        if (this.state.nameState === "success" && this.state.contactNumberState === "success" && this.state.companyNumberState === "success" && this.state.adminNameState === "success") {
            var data = {
                id: this.state.clinicmaster_id,
                clinicmaster_name: this.state.name,
                company_number: this.state.companyNumber,
                admin_name: this.state.adminName,
                contact_info: this.state.contactNumber,

            }
            this.CallUpdateApi(data.id, data);
        }

    }

    CallUpdateApi(id, data) {
        api.updateClinicMasterById(id, data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "ClinicMaster Updated Successfully!", color: "success"};
                    this.props.generateNotification(msgcolor);
                    this.props.history.push(dashboardRouter(`/clinicmaster/oneClinicMaster/${id}`))
                }
            }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.generateNotification(msgcolor);
        })
    }
}



// WEBPACK FOOTER //
// ./src/views/ClinicMasters/updateClinicMaster.jsx